module.exports = __webpack_public_path__ + "static/media/map.d711f695.png";